import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InlineTableData, KeyValuePair } from '@morningstar/shared/models';
import { TableService } from './table-service';
import { Observable } from 'rxjs';

export abstract class InlineTableService<T extends InlineTableData> extends TableService<T> {

  constructor(protected snackbar: MatSnackBar, protected httpClient: HttpClient,
              @Inject('API_BASE_URL') protected baseUrl: string) {
    super(snackbar, httpClient, baseUrl);
  }

  abstract baseEndpoint: string;
  deleteEndpoint: string;
  saveAllInLineDataEndpoint: string;
  params: KeyValuePair[];

  getInlineData(endpoint?: string) {
    this.getList(endpoint || this.baseEndpoint, this.params).subscribe();
  }

  saveAllInlineData(data: T[]): Observable<T[]> {
    const endpoint = this.saveAllInLineDataEndpoint ? this.saveAllInLineDataEndpoint : this.baseEndpoint;
    return this.put(data, endpoint);
  }

  addInlineData(data: T) {
    return this.add(data, this.baseEndpoint, this.params);
  }

  addInlineDataAndUpdateId(data: T): Observable<T> {
    return this.add(data, this.baseEndpoint, this.params);
  }

  updateInlineData(data: T) {
    return this.update(data, this.baseEndpoint, this.params);
  }

  deleteInlineData(id: string | number) {
    const endpoint = this.deleteEndpoint ? this.deleteEndpoint : this.baseEndpoint;
    return this.delete(`${endpoint}/${id}`, this.dataDescription);
  }
}
